import { APPNAME } from 'app/constants';
import { useState } from 'react';

interface UseUserPreferencesProps {
  name: string;
}

const useUserPreferences = ({ name }: UseUserPreferencesProps) => {
  const [preferences, setPreferences] = useState<Record<string, boolean>>(() => {
    const savedPreferences = localStorage.getItem(`${APPNAME}-${name}`);
    return savedPreferences ? JSON.parse(savedPreferences) : {};
  });

  const updatePreference = (key: string, value: boolean) => {
    const updatedPreferences = { ...preferences, [key]: value };
    setPreferences(updatedPreferences);
    localStorage.setItem(`${APPNAME}-${name}`, JSON.stringify(updatedPreferences));
  };

  const getPreference = (key: string): boolean => {
    return preferences[key] || false;
  };

  return { preferences, updatePreference, getPreference };
};

export default useUserPreferences;